import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function MobilePhoneIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M14.1499 1.62012h-8.33c-.92231 0-1.67.74768-1.67 1.67V16.6201c0 .9223.74769 1.67 1.67 1.67h8.33c.9223 0 1.67-.7477 1.67-1.67V3.29012c0-.92232-.7477-1.67-1.67-1.67ZM10 14.96h.01"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
